import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DwButtonCommand, DwButtonConfig, DwDateTimeInputOptions, DwLookupInfo, DwMetaDataService, DwMetaDataServiceToken, DwModalConfig, DwModalHandler, DwModalResult } from '@devwareapps/devware-cap';
import * as moment from 'moment';
import { combineLatest, forkJoin, Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { PermitsV2MetaDataItemNames, Permits2PermitEntity, PermitsV2MetaDataService, NoteTypeAllItems, PermitStatusAllItems, 
         CodeValueInspectionResults, CodeValueInspectionState, Permits2RoInspectionsEntity, ChangeRequestEntity } 
         from '../../meta-data/permitsv2-meta-data.service';
import { PermitRequestService } from '../../services/permit-request.service';
import { PermitService } from '../../services/permit.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-change-request-modal',
  templateUrl: './change-request-modal.component.html',
  styleUrls: ['./change-request-modal.component.scss']
})
export class ChangeRequestModalComponent implements OnInit, DwModalHandler {
  changeRequest: ChangeRequestEntity;
  comment?: string = null;

  constructor(
    @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
  ) { }

  modalConfig: DwModalConfig<any>;
  closeModal: EventEmitter<DwModalResult<any>>;

  ngOnInit(): void {
  }

  /**
   * Handles the modal button actions
   * @param buttonConfig 
   * @returns 
   */
  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult<any>> {
    let modalResult: DwModalResult = {
      cancelled: false,
      buttonCommand: buttonConfig.command,
      closeModal: true,
    };

    if (buttonConfig.command == DwButtonCommand.saveAndClose && (this.comment ?? '').length > 0)
      modalResult.data = this.comment;
    else
      modalResult.cancelled = true;
    return of(modalResult);
  }
  onChange(){
    this.modalConfig.buttons[0].hidden = (this.comment ?? '').length == 0;
  }

}
